module.exports = __webpack_public_path__ + "static/media/Yewen Pu.a20771cb.png";